/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from 'underscore';
import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DefaultButton, PrimaryButton, Link } from '@bingads-webui-react/fabric-with-signal';
import { Text } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getStepBaseLayoutFooterStyles, baseLayoutFooterStyles } from './styles/step-base-layout-footer-styles';

export function StepFooter(props) {
  const {
    onCancelClick,
    onPreviousClick,
    onNextClick,
    nextButtonText,
    previousButtonAfterNext,
    previousButtonText,
    cancelButtonText,
    onSkippingLinkClick,
    skippingLinkTitle,
    onRenderFooterNote,
    isPreviousClickDisabled,
    isNextClickDisabled,
    isSkipLinkDisabled,
    stepProgressContent,
    className,
    styleOverrides,
  } = props;
  const classes = useDefaultStyles(getStepBaseLayoutFooterStyles(styleOverrides));
  const i18n = useContext(I18nContext);

  return (
    <div className={classNames('step-footer', classes.footerContainer, className)}>
      {
        _.isFunction(onRenderFooterNote) && onRenderFooterNote()
      }
      {!previousButtonAfterNext &&
        _.isFunction(onPreviousClick) &&
        <DefaultButton
          className={classNames('step-previous', classes.previousButton)}
          onClick={onPreviousClick}
          disabled={isPreviousClickDisabled}
        >
          {previousButtonText || i18n.getString(_TL_('Previous'))}
        </DefaultButton>
      }

      <PrimaryButton
        className={classNames('step-next')}
        onClick={_.isFunction(onNextClick) ? onNextClick : null}
        disabled={!_.isFunction(onNextClick) || isNextClickDisabled}
      >
        {nextButtonText || i18n.getString(_TL_('Next'))}
      </PrimaryButton>

      {previousButtonAfterNext &&
        _.isFunction(onPreviousClick) &&
        <DefaultButton
          className={classNames('step-previous', classes.previousButtonOnTheRightOfNext)}
          onClick={onPreviousClick}
          disabled={isPreviousClickDisabled}
        >
          {previousButtonText || i18n.getString(_TL_('Previous'))}
        </DefaultButton>
      }

      {
        _.isFunction(onCancelClick) &&
        <DefaultButton
          className={classNames('step-cancel', classes.cancelButton)}
          onClick={onCancelClick}
        >
          {cancelButtonText || i18n.getString(_TL_('Cancel'))}
        </DefaultButton>
      }

      {
        stepProgressContent &&
        <div className={classNames('step-progress-container', classes.stepProgressContainer)}>
          <Text
            variant="medium"
            block
            styles={baseLayoutFooterStyles.stepProgress}
            className="step-progress"
          >
            {stepProgressContent}
          </Text>
        </div>
      }

      {
        _.isFunction(onSkippingLinkClick) &&
        <Link
          className={classNames(['link-button', 'step-skip', classes.skippingLink])}
          onClick={onSkippingLinkClick}
          disabled={isSkipLinkDisabled}
        >
          {skippingLinkTitle || i18n.getString(_TL_('Skip campaign creation'))}
        </Link>
      }
    </div>
  );
}

StepFooter.propTypes = {
  onCancelClick: PropTypes.func,
  onPreviousClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onNextClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onSkippingLinkClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  skippingLinkTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),

  onRenderFooterNote: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

  previousButtonAfterNext: PropTypes.bool,
  previousButtonText: PropTypes.string,
  nextButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  isPreviousClickDisabled: PropTypes.bool,
  isNextClickDisabled: PropTypes.bool,
  isSkipLinkDisabled: PropTypes.bool,
  className: PropTypes.string,
  styleOverrides: PropTypes.shape({}),
  stepProgressContent: PropTypes.string,
};

StepFooter.defaultProps = {
  previousButtonAfterNext: false,
  previousButtonText: null,
  nextButtonText: null,
  cancelButtonText: null,
  onPreviousClick: null,
  onNextClick: null,
  onCancelClick: null,
  onSkippingLinkClick: null,
  skippingLinkTitle: null,
  onRenderFooterNote: null,

  isPreviousClickDisabled: false,
  isNextClickDisabled: false,
  isSkipLinkDisabled: false,
  className: '',
  styleOverrides: undefined,
  stepProgressContent: '',
};
